<template>
  <div
    v-if="isActive"
    class="route-progress"
    :class="{ 'route-progress--done': isFinishing, 'route-progress--light': isFleetPartnerOnly }"
  >
    <div class="route-progress__bar"></div>
  </div>
</template>

<script setup>
import { useNavigationProgress } from '@/composables/useNavigationProgress';
import { usePartnerType } from '@/composables/common';

const { isActive, isFinishing } = useNavigationProgress();
const { isFleetPartnerOnly } = usePartnerType();
</script>

<style scoped lang="scss">
.route-progress {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  height: 3px;
  z-index: 2000;
  pointer-events: none;

  &__bar {
    height: 100%;
    width: 0;
    background-color: var(--theme-default);
    animation: route-progress-creep 10s ease-out forwards;
    transition: width 0.2s ease, opacity 0.3s ease; // opacity .3s MUST match FINISH_FADE_MS
  }

  &--done &__bar {
    width: 100%;
    animation: none;
    opacity: 0;
  }

  &--light &__bar {
    background-color: var(--white);
  }
}

@keyframes route-progress-creep {
  0% {
    width: 0;
  }

  100% {
    width: 90%;
  }
}
</style>
